import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { ServiceUsage } from "@/lib/api";

/** A monthly budget field in the service's unit. */
export function BudgetInput({
  unit,
  value,
  onChange,
  id,
  optional = false,
}: {
  unit: ServiceUsage["unit"];
  value: string;
  onChange: (value: string) => void;
  id: string;
  /** Empty puts the service back on the environment default. */
  optional?: boolean;
}) {
  const label = unit === "usd" ? "Monthly budget (USD)" : "Monthly budget (requests)";
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{optional ? `${label}, empty: the default` : label}</Label>
      <Input
        id={id}
        inputMode={unit === "usd" ? "decimal" : "numeric"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={unit === "usd" ? "e.g. 50.00" : "e.g. 5000"}
      />
    </div>
  );
}
